import type { DeviceApi } from './deviceApi'
import type { DeviceApiClientName } from './clientName'

/**
 * Stores various information about the client exposed by deviceApi.
 */
export interface ClientInfo {
  name: DeviceApiClientName
  version: string
}

export function buildClientInfo(deviceApi: DeviceApi): ClientInfo {
  return {
    name: deviceApi.getClientName(),
    version: deviceApi.getClientVersion()
  }
}
